import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import SeeAllLink from 'components/SeeAllLink';
import Hidden from '@material-ui/core/Hidden';

function ResourcesLinkBtn({ link }) {
  return (
    <Grid item xs={12}>
      <Grid container direction="row" justify="space-between">
        <Grid item xs={12} sm={8} />
        <Hidden xsDown>
          <SeeAllLink link={link} label="More in Resources View" />
        </Hidden>
      </Grid>
    </Grid>
  );
}

ResourcesLinkBtn.propTypes = {
  link: PropTypes.string,
};

export default ResourcesLinkBtn;
